module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "mod4 flex-row"
  }, [_c('span', {
    staticClass: "secondary-title",
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("上传实物信息表")]), _vm._v(" "), _c('span', {
    staticClass: "txt",
    on: {
      "click": _vm.downloadGoodsInfoSheet
    }
  }, [_vm._v("下载实物信息表")])]), _vm._v(" "), _vm._l((_vm.orderMaterialInfo.orderMaterial), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "goods-info-sheet"
    }, [_c('div', {
      staticClass: "sheet-content"
    }, [_c('label', {
      staticClass: "label-checkbox item-content",
      on: {
        "click": function($event) {
          return _vm.getChange(item.orderMaterialDetail)
        }
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.orderMaterial.isChecked),
        expression: "item.orderMaterial.isChecked"
      }],
      attrs: {
        "type": "checkbox",
        "disabled": _vm.isDisabled(item)
      },
      domProps: {
        "value": item.orderMaterial.orderMaterialId,
        "checked": Array.isArray(item.orderMaterial.isChecked) ? _vm._i(item.orderMaterial.isChecked, item.orderMaterial.orderMaterialId) > -1 : (item.orderMaterial.isChecked)
      },
      on: {
        "change": function($event) {
          var $$a = item.orderMaterial.isChecked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.orderMaterial.orderMaterialId,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(item.orderMaterial, "isChecked", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(item.orderMaterial, "isChecked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(item.orderMaterial, "isChecked", $$c)
          }
        }
      }
    }), _vm._v(" "), _vm._m(0, true)]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "5px",
        "margin-left": "15px"
      }
    }, [_c('display-icon-and-status', {
      attrs: {
        "materialType": item.orderMaterial.materialType,
        "displayType": _vm.emkt.SAMPLE_DISPLAY_TYPE.DISPLAY_ICON
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "outer1 flex-col"
    }, [_c('span', {
      staticClass: "word2"
    }, [_vm._v(_vm._s(item.orderMaterial.materialDesc))]), _vm._v(" "), _c('span', {
      staticClass: "txt4"
    }, [_vm._v("用于" + _vm._s(item.orderMaterial.euName))])]), _vm._v(" "), (item.orderMaterialDetail && item.orderMaterialDetail.fileName) ? _c('div', [_c('img', {
      staticClass: "label2",
      attrs: {
        "src": _vm.emkt.getOrderMaterialFileShowIcon(item.orderMaterialDetail.fileName)
      }
    }), _vm._v(" "), _c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.disAllowUploadOrDelete(item)),
        expression: "!disAllowUploadOrDelete(item)"
      }],
      staticClass: "icon5",
      attrs: {
        "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'other/删除.svg'
      },
      on: {
        "click": function($event) {
          return _vm.removeFile(item)
        }
      }
    })]) : _c('div', {
      staticClass: "upload"
    }, [_c('img', {
      staticClass: "upload-icon",
      attrs: {
        "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'other/上传.svg'
      }
    }), _vm._v(" "), _c('input', {
      staticClass: "uplaod-input",
      attrs: {
        "type": "file"
      },
      on: {
        "change": function($event) {
          return _vm.uploadFile($event, item)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "upload-word"
    }, [_vm._v("上传文档")])])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "mod6"
  }, [_c('span', {
    staticClass: "info2"
  }, [_vm._v("\n      请勾选您本次寄出的物品，务必完整填写《实物信息表》全部相关信息，将文档直接上传。推荐在电脑端使用小程序完成上传操作。\n    ")]), _vm._v(" "), _c('span', {
    staticClass: "txt",
    on: {
      "click": _vm.showMiniProgramInComputerUsage
    }
  }, [_vm._v("查看小程序在电脑端的使用方法")])]), _vm._v(" "), _c('span', {
    staticClass: "secondary-title"
  }, [_vm._v("寄出快递")]), _vm._v(" "), _c('div', {
    staticClass: "address"
  }, [_c('div', {
    staticClass: "wrap flex-col"
  }, [_c('div', {
    staticClass: "box7 flex-row"
  }, [_c('img', {
    staticClass: "icon9",
    attrs: {
      "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'other/地址.svg'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "address-content"
  }, [_vm._v(_vm._s(_vm.emkt.DELIVERY_ADDRESS.ADDRESS))]), _vm._v(" "), _c('button', {
    staticClass: "group2 flex-col",
    attrs: {
      "data-clipboard-text": '收件人姓名：' + _vm.emkt.DELIVERY_ADDRESS.RECEIVER + '\n电话：' + _vm.emkt.DELIVERY_ADDRESS.PHONE + '\n地址信息：' + _vm.emkt.DELIVERY_ADDRESS.ADDRESS,
      "id": "tag-copy"
    },
    on: {
      "click": _vm.copy
    }
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("复制")])])]), _vm._v(" "), _c('div', {
    staticClass: "box8 flex-row"
  }, [_c('span', {
    staticClass: "info4"
  }, [_vm._v(_vm._s(_vm.emkt.DELIVERY_ADDRESS.RECEIVER))]), _vm._v(" "), _c('span', {
    staticClass: "info4"
  }, [_vm._v(_vm._s(_vm.emkt.DELIVERY_ADDRESS.PHONE))])]), _vm._v(" "), _c('div', {
    staticClass: "line flex-col"
  }), _vm._v(" "), _c('div', {
    staticClass: "box10 flex-row"
  }, [_c('img', {
    staticClass: "outer4",
    attrs: {
      "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'other/顺丰logo.svg'
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "delivery-icon flex-col"
  }, [_c('span', {
    staticClass: "tag",
    on: {
      "click": _vm.openShunFengProgram
    }
  }, [_vm._v("打开")])])])]), _vm._v(" "), _c('img', {
    staticClass: "delivery flex-col",
    attrs: {
      "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'other/express.png'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('van-row', _vm._l((_vm.expressCategoryList), function(item, index) {
    return _c('van-col', {
      key: index,
      attrs: {
        "span": 24 / _vm.expressCategoryList.length
      }
    }, [_c('van-button', {
      staticClass: "express-category",
      attrs: {
        "round": "",
        "size": "small",
        "block": "",
        "plain": _vm.plain[index],
        "color": "#5878FA"
      },
      on: {
        "click": function($event) {
          return _vm.onChange(index)
        }
      }
    }, [_vm._v(_vm._s(item))])], 1)
  }), 1)], 1), _vm._v(" "), (_vm.plain[0]) ? _c('div', [_c('span', {
    staticClass: "secondary-title"
  }, [_vm._v("填写快递单号")]), _vm._v(" "), _c('ul', {
    staticClass: "express-block"
  }, _vm._l((_vm.expressList), function(express, index) {
    return _c('li', {
      staticClass: "express-content",
      class: {
        'active': index === _vm.expressIndex
      },
      on: {
        "click": function($event) {
          return _vm.chooseExpress(express, index)
        }
      }
    }, [_c('img', {
      staticClass: "icon-express",
      attrs: {
        "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'express/' + express + '.png'
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "express-font"
    }, [_vm._v(_vm._s(express))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "block9 flex-col"
  }, [_c('div', {
    staticClass: "bd4 flex-col"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.expressNo),
      expression: "expressNo",
      modifiers: {
        "trim": true
      }
    }],
    ref: "content",
    staticClass: "word19",
    attrs: {
      "type": "text",
      "placeholder": "请输入快递单号"
    },
    domProps: {
      "value": (_vm.expressNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.expressNo = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-content"
  }, [_c('div', {
    staticClass: "save-btn",
    on: {
      "click": _vm.saveSampleDelivery
    }
  }, [_c('span', {
    staticClass: "save-tag"
  }, [_vm._v("保存")])])])])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media group"
  }, [_c('i', {
    staticClass: "icon icon-form-checkbox i-style",
    staticStyle: {
      "margin-top": "10px",
      "width": "20px",
      "height": "20px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "paragraph1"
  }, [_vm._v("\n          打开顺丰小程序\n          "), _c('br'), _vm._v("\n          选择货到付款，快捷寄件\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "color": "#D2D2D6",
      "text-align": "center",
      "pointer-events": "none"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "12px",
      "margin-bottom": "50%"
    }
  }, [_vm._v("---我是有底线的---")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d8fb65a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views_v_2.6/Material/AddSampleDeliverySheet.vue
// module id = 1627
// module chunks = 8